/* Variante — RJ-10 (Bible §21).
   One editor component, two entry points: the Campaign builder and any
   Journey Stage. Editable: type, share, Destination, timer profile, roue,
   fallback and invitation copy. Locked, and not shown as if they were
   choices: « Passer », the guaranteed reveal, and the guardrail line. */
import { Field, Input, Note } from '@/ui'
import { MOMENTS } from '@/lib/campaign'
import { Retour } from './parts'

const moment = (id: string) => MOMENTS.find(m => m.id === id)?.title ?? id

const CHAMPS: Array<[string, string]> = [
  ['Moment', moment('pendant')],
  ['Fréquence d’apparition', '35 %'],
  ['Lien d’avis', 'Google Reviews — Paris 9 ✓'],
  ['Profil de compte à rebours', 'Standard 30 s (réutilisable)'],
  ['Roue', 'Roue du salon — celle de la campagne'],
  ['Repli si indisponible', 'Cadeau seul'],
]

export default function Variante() {
  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 760 }}>
      <Retour />
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, flexWrap: 'wrap' }}>
        <h2 className="t-page" style={{ margin: 0 }}>Variante — «&nbsp;Invitation Google&nbsp;»</h2>
        <span className="f-help" style={{ marginLeft: 'auto' }}>Étape 3 · enregistré 14:02</span>
      </div>

      <div style={{ display: 'grid', gap: 12, gridTemplateColumns: '1fr 1fr' }}>
        {CHAMPS.map(([label, value]) => (
          <Field key={label} label={label}>{id => <Input id={id} defaultValue={value} />}</Field>
        ))}
      </div>

      <Field label="Texte d’invitation (FR — modifiable)">
        {id => <Input id={id} defaultValue="Profitez-en pour partager votre expérience sur Google." />}
      </Field>

      <Note tone="ok">
        Aperçu en direct&nbsp;: popup, boutons et ligne d’assurance se mettent à jour.
        «&nbsp;Passer&nbsp;» et la révélation garantie ne sont pas modifiables.
      </Note>
    </div>
  )
}
